<template>
  <v-container class="contact-page" fluid>
    <div class="head-wrap mb-4">
      <div>
        <h1 class="headline mb-1">ESG Activities <span class="thai">กิจกรรมความยั่งยืน</span></h1>
        <p class="subhead mb-0">Manage sustainability and PSARN activity posts shown on the corporate site.</p>
      </div>
      <v-btn v-if="canAdd" class="setup-btn" color="primary" @click="$router.push({name: 'esg-create'})">
        <v-icon left small>mdi-plus</v-icon>
        Create Activity
      </v-btn>
    </div>

    <v-card class="table-card">
      <div class="filter-bar">
        <div class="search-wrap">
          <v-text-field v-model="searchText" append-icon="mdi-magnify" outlined dense hide-details label="Search by activity title..." clearable @input="onSearch" />
        </div>
      </div>

      <v-data-table :loading="isPageLoading" :headers="headers" :items="list" :items-per-page="10" hide-default-footer class="contact-table">
        <template v-slot:item.no="{index, item}">{{ rowNo(index, item) }}</template>
        <template v-slot:item.title="{item}">
          <div class="title-wrap">
            <strong>{{ item.title_en || item.title_th || '-' }}</strong>
            <div class="title-sub">{{ item.title_th || '-' }}</div>
          </div>
        </template>
        <template v-slot:item.event_date="{item}">{{ formatDate(item.event_date) }}</template>
        <template v-slot:item.action="{item}">
          <button v-if="canEdit" class="icon-btn" @click.stop="goToEdit(item)"><v-icon size="16">mdi-pencil-outline</v-icon></button>
          <button v-if="canDelete" class="icon-btn ml-2" @click.stop="remove(item)"><v-icon size="16">mdi-delete-outline</v-icon></button>
        </template>
      </v-data-table>

      <div class="table-foot">Showing 1 to {{ list.length }} of {{ list.length }} entries</div>
    </v-card>

  </v-container>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import {hasPermision} from '@/helper/helper'

export default {
  data() {
    return {
      searchText: '',
      localLoading: false,
      headers: [
        {text: 'NO.', value: 'no', sortable: false, width: 70},
        {text: 'ACTIVITY TITLE', value: 'title', sortable: false},
        {text: 'EVENT DATE', value: 'event_date', sortable: false, width: 200},
        {text: 'ACTIONS', value: 'action', sortable: false, width: 120, align: 'center'}
      ]
    }
  },
  computed: {
    ...mapState('esgActivities', ['list', 'isLoading']),
    canAdd() { return hasPermision('CanAddEsg') },
    canEdit() { return hasPermision('CanEditEsg') },
    canDelete() { return hasPermision('CanDeleteEsg') },
    isPageLoading() {
      return this.localLoading || this.isLoading
    }
  },
  async created() {
    this.localLoading = true
    try {
      this.setResource('esg')
      this.setTextSearch('')
      await this.fetch()
    } finally {
      this.localLoading = false
    }
  },
  methods: {
    ...mapActions('esgActivities', ['setResource', 'fetch', 'setTextSearch', 'deleteById']),
    rowNo(index, item) {
      let rowIndex = Number(index)
      if (Number.isNaN(rowIndex)) {
        const fallbackIndex = (this.list || []).findIndex((listItem) => {
          if (item && item.id && listItem.id) return String(listItem.id) === String(item.id)
          return listItem === item
        })
        rowIndex = fallbackIndex >= 0 ? fallbackIndex : 0
      }
      return rowIndex + 1
    },
    formatDate(value) {
      if (!value) return '-'
      const date = new Date(value)
      if (Number.isNaN(date.getTime())) return '-'
      const day = String(date.getDate()).padStart(2, '0')
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const year = date.getFullYear()
      return `${day}/${month}/${year}`
    },
    async onSearch() {
      this.localLoading = true
      try {
        this.setTextSearch(this.searchText || '')
        await this.fetch()
      } finally {
        this.localLoading = false
      }
    },
    goToEdit(item) {
      this.$router.push({name: 'esg-edit', params: {id: item.id}})
    },
    async remove(item) {
      if (!window.confirm('Delete this record?')) return
      this.localLoading = true
      try {
        const ok = await this.deleteById(item.id)
        if (ok) await this.fetch()
      } finally {
        this.localLoading = false
      }
    }
  }
}
</script>

<style scoped>
.contact-page { background: #f7f9fc; min-height: calc(100vh - 120px); }
.head-wrap { display: flex; justify-content: space-between; align-items: flex-start; gap: 12px; }
.headline { font-size: 30px !important; color: #0f1f3b; }
.thai { color: #64748b; font-size: 15px; font-weight: 500; margin-left: 6px; }
.subhead { color: #64748b; font-size: 13px; }
.setup-btn { text-transform: none; font-weight: 700; border-radius: 10px; }
.table-card { border: 1px solid #e6e9f0; border-radius: 10px; box-shadow: none; overflow: hidden; }
.filter-bar { display: flex; gap: 10px; padding: 14px; border-bottom: 1px solid #edf2fb; }
.search-wrap { flex: 1; }
.title-wrap { line-height: 1.25; }
.title-sub { color: #7284a5; font-size: 13px; }
.icon-btn { width: 30px; height: 30px; border-radius: 7px; border: 1px solid #e6e9f0; background: #fff; }
.table-foot { padding: 14px 16px; border-top: 1px solid #edf2fb; color: #64748b; font-size: 12px; }
.contact-table::v-deep .v-data-table-header th { color: #7c8aa5 !important; font-size: 12px; font-weight: 700; }
.contact-table::v-deep td { font-size: 14px; }
</style>
